module.exports = __webpack_public_path__ + "fonts/Lato-900-9.49bb7a6.woff2";